export default __webpack_public_path__ + "static/media/img-0607-liechtenstein-half-face.e39e8c83.png";